module.exports = __webpack_public_path__ + "static/media/panda-party-resumen.03380da0.png";